/**
 * The same mark the page draws before any of this ran.
 *
 * index.html carries this markup verbatim so that something is on screen
 * while the bundle is still arriving, and React clears it the moment it
 * mounts. Without a copy to render, signing in would blink: a shutter, then
 * nothing, then a spinner, then the app. The two are the same drawing and the
 * same classes, so the handover cannot be seen.
 *
 * If the shape of the mark is ever changed, it has to be changed in both —
 * they are one picture kept in two places because one of them has to exist
 * before JavaScript does.
 */
export function Booting() {
  return (
    <div className="boot">
      <svg className="boot-mark" viewBox="0 0 512 512" role="img" aria-label="Loading">
        {/* Lit as icon.svg is, and as index.html's copy is; see there. */}
        <defs>
          <linearGradient id="boot-ink" x1="0" y1="126" x2="0" y2="386" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#FFFFFF" />
            <stop offset="1" stopColor="#E3ECFD" />
          </linearGradient>
          <linearGradient
            id="boot-iris-ink"
            x1="0"
            y1="-130"
            x2="0"
            y2="130"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#FFFFFF" />
            <stop offset="1" stopColor="#E3ECFD" />
          </linearGradient>
          <linearGradient id="boot-glass" x1="-51" y1="-58" x2="50" y2="58" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#78A6FA" />
            <stop offset="1" stopColor="#2A5CCC" />
          </linearGradient>
          <filter id="boot-lift" x="-25%" y="-25%" width="150%" height="160%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="8" />
            <feOffset dy="9" result="blur" />
            <feFlood floodColor="#0A1A45" floodOpacity="0.42" />
            <feComposite in2="blur" operator="in" />
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id="boot-soft" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2.5" />
          </filter>
        </defs>
        <rect width="512" height="512" rx="114" fill="#4680F2" />
        <g transform="translate(7 0)" filter="url(#boot-lift)">
          <path
            d="M361.2 179.6 A 130 130 0 1 0 361.2 332.4 L361.2 256"
            fill="none"
            stroke="url(#boot-ink)"
            strokeWidth="44"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M361.2 256 L306.2 256"
            fill="none"
            stroke="url(#boot-ink)"
            strokeWidth="44"
            strokeLinecap="butt"
          />
        </g>
        {/* Drawn around its own origin so it shuts on its own centre, glass and
            glint with it; see index.html, which carries the same mark. */}
        <g transform="translate(263 256)">
          <g className="boot-iris">
            <path
              d="M0 -58 L50.2 -29 L50.2 29 L0 58 L-50.2 29 L-50.2 -29 Z"
              fill="url(#boot-glass)"
            />
            <ellipse
              cx="-20"
              cy="-24"
              rx="15"
              ry="8"
              transform="rotate(-30 -20 -24)"
              fill="#FFFFFF"
              fillOpacity="0.7"
              filter="url(#boot-soft)"
            />
            <path
              d="M0 -58 L50.2 -29 L50.2 29 L0 58 L-50.2 29 L-50.2 -29 Z"
              fill="none"
              stroke="url(#boot-iris-ink)"
              strokeWidth="16"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <rect className="boot-flash" width="512" height="512" rx="114" fill="#fff" />
      </svg>
    </div>
  );
}
